import { type CurrencyType, currencies } from '@/config/currencies';
import { Avatar, Box, Button, Group, Menu, ScrollArea, Text } from '@mantine/core';
import { useState } from 'react';
import { Icons } from './Icons';
import classes from './Selected.module.css';
export const CurrencySelected: React.FC = () => {
  const [currency, setCurrency] = useState<CurrencyType>(currencies[0]);
  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);
  return <Menu shadow="md" width={320} withinPortal={false} position="bottom-end" classNames={classes} onChange={() => setMenuIsOpen(!menuIsOpen)}>
      <Menu.Target>
        <Button px={0} variant="transparent" style={{
        pointerEvents: 'auto'
      }} classNames={{
        section: classes.section
      }} rightSection={<Box mod={{
        active: menuIsOpen
      }} className={classes.iconStyle}>
              <Icons className="icon-pr-line-chevron-down" fontSize={24} />
            </Box>}>
          <Group gap={8}>
            <Avatar src={currency.icon} size={24} variant="transparent" />
            <Text fz={13} c="var(--text-dark)">
              {currency.code}
            </Text>
          </Group>
        </Button>
      </Menu.Target>

      <Menu.Dropdown style={{
      pointerEvents: 'auto'
    }}>
        <ScrollArea h={280} offsetScrollbars classNames={classes}>
          {currencies.map(item => <Menu.Item key={item.name} mod={{
          active: item.code === currency.code
        }} leftSection={<Avatar variant="transparent" src={item.icon} size={24} />} onClick={() => setCurrency(item)}>
              <Text fz="xs" fw={700}>
                {item.code}
                <Text span inherit fw={500}>
                  {` (${item.name})`}
                </Text>
              </Text>
            </Menu.Item>)}
        </ScrollArea>
      </Menu.Dropdown>
    </Menu>;
};